<div class="content-layout">

    <!-- Toaster -->
    <toaster-container [toasterconfig]="toasterConfig"></toaster-container>

    <!-- Header -->
    <app-header class="header"></app-header>

    <mat-sidenav-container class="container">
        <mat-sidenav-content class="content o-visible_">
            <router-outlet></router-outlet>
        </mat-sidenav-content>
    </mat-sidenav-container>

    <!-- Footer -->
    <app-footer></app-footer>
</div>
